function videoPlaylistTabs() {
	const playlists = document.querySelectorAll('.js-video-playlist');

	if (!playlists.length) return; // Exit early if element is not found in the DOM.

	// Function to handle height calculation and application
	const applyDynamicHeight = () => {
		const isDesktop = window.innerWidth > 849;

		playlists.forEach((playlist) => {
			const panels = playlist.querySelectorAll('[data-tab-panel]');
			const playlistContainer = playlist.querySelector('.video-playlist__content') || playlist;

			// Remove the class and reset height if not desktop
			if (!isDesktop) {
				playlistContainer.classList.remove('has-dynamic-height');
				playlistContainer.style.height = '';
				return;
			}

			// Calculate the highest panel height
			let maxHeight = 0;
			panels.forEach((panel) => {
				const height = panel.offsetHeight;
				if (height > maxHeight) {
					maxHeight = height;
				}
			});

			// Apply the highest height to the playlist container
			playlistContainer.style.height = `${maxHeight}px`;

			// Add CSS class to indicate dynamic height has been applied
			playlistContainer.classList.add('has-dynamic-height');
		});
	};

	// Apply height on initial load.
	applyDynamicHeight();

	// Reapply height on window resize
	window.addEventListener('resize', applyDynamicHeight);

	// Handle tabbing.
	playlists.forEach((playlist) => {
		const triggers = playlist.querySelectorAll('[data-tab-trigger]');
		const panels = playlist.querySelectorAll('[data-tab-panel]');

		triggers.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				const target = trigger.getAttribute('data-tab-trigger');

				// Remove active classes
				triggers.forEach((t) => t.classList.remove('is-active'));
				panels.forEach((p) => p.classList.remove('is-active'));

				// Add active to clicked trigger and matching panel(s)
				trigger.classList.add('is-active');
				panels.forEach((panel) => {
					if (panel.getAttribute('data-tab-panel') === target) {
						panel.classList.add('is-active');
					}
				});
			});
		});
	});
}

function videoPlaylistTitleMobile() {
	const titleMobile = document.querySelectorAll('.wp-block-embark-video-playlist__title-mobile');
	const titleDesktop = document.querySelectorAll('.wp-block-embark-video-playlist__title');

	if (!titleMobile.length || !titleDesktop.length) return;

	function updateMobileTitles() {
		if (window.innerWidth < 849) {
			titleDesktop.forEach((desktopTitle, index) => {
				if (titleMobile[index]) {
					// Clear existing content
					titleMobile[index].innerHTML = '';
					// Create and append h2 element
					const h2Element = document.createElement('h2');
					h2Element.textContent = desktopTitle.textContent;
					titleMobile[index].appendChild(h2Element);
				}
			});
		}
	}

	// Initial check
	updateMobileTitles();

	// Add resize listener
	window.addEventListener('resize', updateMobileTitles);
}

/**
 * Auto-clicks Wistia video links when URL hash matches video ID
 * Example: URL with #xizk3yt9oi will auto-play video from catalystpharma.wistia.com/medias/xizk3yt9oi
 */
function videoAutoplayWistiaURLHash() {
	// Configuration for timing and matching
	const config = {
		maxWaitAttempts: 20, // Wait up to 10 seconds for lightbox system
		checkInterval: 500, // Check every 500ms
		initialDelay: 500, // Initial delay before starting
		wistiaRegex: /wistia\.com\/medias\/([a-z0-9]+)/i,
	};

	// Helper functions
	const extractWistiaId = (url) => url?.match(config.wistiaRegex)?.[1] || null;
	const getVideoLightboxSystem = () => window.embark?.components?.lightboxes;

	// Check if element is already processed by VideoLightbox system
	const isElementProcessedByLightbox = (element) => {
		const system = getVideoLightboxSystem();
		return system?.videoLightboxes?.some((lightbox) => lightbox.el === element) || false;
	};

	const findSpecificLightbox = (element) => {
		const system = getVideoLightboxSystem();
		return system?.videoLightboxes?.find((lightbox) => lightbox.el === element);
	};

	// Manually trigger lightbox without user interaction
	const triggerLightboxDirectly = (lightbox, element) => {
		const mockEvent = {
			preventDefault: () => {},
			stopPropagation: () => {},
			target: element,
			currentTarget: element,
		};
		return lightbox.handleClickCallback(mockEvent);
	};

	// Safely click element - ensures lightbox opens instead of redirecting
	const clickElementSafely = (element) => {
		if (isElementProcessedByLightbox(element)) {
			element.click();
			return true;
		}

		// Element not ready, try to reinitialize VideoLightbox system
		const system = getVideoLightboxSystem();

		if (system?.initVideoLightboxes) {
			system.initVideoLightboxes();

			// Wait for reinitialization then trigger
			setTimeout(() => {
				const specificLightbox = findSpecificLightbox(element);

				if (specificLightbox) {
					triggerLightboxDirectly(specificLightbox, element);
				} else {
					element.click(); // Fallback to regular click
				}
			}, 100);

			return true;
		}

		// No lightbox system available - regular click (may redirect)
		element.click();
		return true;
	};

	// Get hash from URL (without # symbol)
	const currentHash = window.location.hash.substring(1);

	// Exit early if no hash present
	if (!currentHash) return;

	// Wait for VideoLightbox system to be ready then search for matching video
	const waitForSystem = (attempts = 0) => {
		const system = getVideoLightboxSystem();
		const isReady = system?.videoLightboxes?.length > 0;
		const hasElements = document.querySelectorAll('a[href*="wistia"]').length > 0;

		if (isReady && hasElements) {
			// System ready - find and click matching video
			const wistiaLinks = Array.from(document.querySelectorAll('a[href*="wistia"]'));

			wistiaLinks.some((link) => {
				const videoId = extractWistiaId(link.href);

				if (videoId === currentHash) {
					clickElementSafely(link);
					return true; // Stop searching
				}
				return false;
			});
		} else if (attempts < config.maxWaitAttempts - 1) {
			// System not ready - retry after delay
			setTimeout(() => waitForSystem(attempts + 1), config.checkInterval);
		}
		// If max attempts reached, give up silently
	};

	// Start the process after initial delay
	setTimeout(() => waitForSystem(), config.initialDelay);
}

document.addEventListener('DOMContentLoaded', () => {
	videoPlaylistTabs();
	videoPlaylistTitleMobile();
	videoAutoplayWistiaURLHash();
});
